"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var render_app_1 = __importDefault(require("../../utils/render-app"));
var app_1 = __importDefault(require("../quiz-diaper-bundle/app"));
var app_2 = __importDefault(require("./app"));
var error_boundary_1 = __importDefault(require("./error-boundary"));
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    },
});
var QuizOrBundler = function (_a) {
    var quizCmsSettings = _a.quizCmsSettings, bundlerCmsSettings = _a.bundlerCmsSettings;
    var _b = __read((0, react_1.useState)(function () { return window.location.href.includes('q=1'); }), 2), showQuiz = _b[0], setShowQuiz = _b[1];
    if (!bundlerCmsSettings)
        return null;
    var designVariants = bundlerCmsSettings.designVariants, backgroundImages = bundlerCmsSettings.backgroundImages;
    var backgroundClassName = (function () {
        switch (designVariants.background) {
            case 'blue_blank':
                return 'bg-light-blue';
            case 'orange_with_semicircle':
                return 'bg-hb-marigold';
        }
    })();
    var extraVariantBackgroundElement = (function () {
        switch (designVariants.background) {
            case 'blue_blank':
                return react_1.default.createElement(react_1.default.Fragment, null);
            case 'orange_with_semicircle':
                return (
                /** a playful semicircle */
                react_1.default.createElement("div", { className: 'bg-intense-marigold', style: { position: 'absolute', bottom: 0, height: '90%', width: '103%', borderTopLeftRadius: 99999, borderTopRightRadius: 99999 } }));
        }
    })();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('bundler-v2-app--background-images-container position-fixed z1 flex-container align-center height-100 width-100', backgroundClassName) },
            extraVariantBackgroundElement,
            backgroundImages.img1 && (react_1.default.createElement("img", { src: backgroundImages.img1.src, alt: backgroundImages.img1.alt, className: 'position-absolute height-100', style: { maxHeight: 100, top: 100, left: 200 } })),
            backgroundImages.img2 && (react_1.default.createElement("img", { src: backgroundImages.img2.src, alt: backgroundImages.img2.alt, className: 'position-absolute height-100', style: { maxHeight: 150, top: 350, left: 10 } })),
            backgroundImages.img3 && (react_1.default.createElement("img", { src: backgroundImages.img3.src, alt: backgroundImages.img3.alt, className: 'position-absolute height-100', style: { maxHeight: 120, top: 600, left: 350 } })),
            backgroundImages.img4 && (react_1.default.createElement("img", { src: backgroundImages.img4.src, alt: backgroundImages.img4.alt, className: 'position-absolute height-100', style: { maxHeight: 110, top: 145, right: 200 } })),
            backgroundImages.img5 && (react_1.default.createElement("img", { src: backgroundImages.img5.src, alt: backgroundImages.img5.alt, className: 'position-absolute height-100', style: { maxHeight: 170, top: 500, right: 50 } }))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('height-100 width-100 flex-container', backgroundClassName) }, showQuiz ? react_1.default.createElement(app_1.default, { cmsSettings: quizCmsSettings, onFinishQuiz: function () { return setShowQuiz(false); } }) : react_1.default.createElement(app_2.default, __assign({}, bundlerCmsSettings)))));
};
var Index = function () {
    if (!window.diaperBundlerV2App)
        return null;
    return (react_1.default.createElement(error_boundary_1.default, null,
        react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
            react_1.default.createElement(QuizOrBundler, { bundlerCmsSettings: window.diaperBundlerV2App, quizCmsSettings: window.quizDiaperBundleApp }))));
};
(0, render_app_1.default)('data-bundler-v2-app', function () { return react_1.default.createElement(Index, null); });
